import React, {useEffect, useState} from 'react';
import {GET_COLLECTION_AGGREGATE_DATA, SEARCH_COLLECTION_URL} from '../../../api';
import 'datatables.net';
import 'datatables.net-responsive';
import $ from "jquery";
import cogoToast from "cogo-toast";
import {admin, organisation, policy} from "api/app";
import {capitalize} from "utils/capitalize";
import {Link} from "react-router-dom";
import Wizard from "../../../components/common/Wizard";

const Organisation = () => {

    document.title = "Organisation";

    const [stateReady, setStateReady] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [editId, setEditId] = useState(0);
    const [wizard, setWizard] = useState(false);
    const [datatable] = useState({
        account: false,
        permission: false
    });

    const RESOURCES = [
        { resource: "account",      view: null,                        manage: "#ck_account" },
        { resource: "finance",      view: "#ck_view_financial",        manage: "#ck_manage_financial" },
        { resource: "waste",        view: "#ck_view_waste_collection", manage: "#ck_manage_waste_collection" },
        { resource: "organisation", view: "#ck_view_organisation",     manage: "#ck_manage_organisation" },
        { resource: "zone",         view: "#ck_view_zone",             manage: "#ck_manage_zone" },
        { resource: "product",      view: "#ck_view_product",          manage: "#ck_manage_product" },
        { resource: "user",         view: "#ck_view_customer",         manage: "#ck_manage_customer" },
        { resource: "payout",       view: "#ck_view_payout",           manage: "#ck_manage_payout" },
        { resource: "collector",    view: "#ck_view_collector",        manage: "#ck_manage_collector" },
        { resource: "report",       view: "#ck_view_report",           manage: "#ck_manage_report" },
        { resource: "commission",   view: "#ck_view_commission",       manage: "#ck_manage_commission" },
        { resource: "qr_code",      view: "#ck_view_qrcode",           manage: "#ck_manage_qrcode" },
        { resource: "enquire",      view: "#ck_view_enquiry",          manage: "#ck_manage_enquiry" },
        { resource: "media",        view: "#ck_view_media",            manage: "#ck_manage_media" },
        { resource: "message",      view: "#ck_view_message",          manage: "#ck_manage_message" },
    ];

    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        let table = $('#organisation-dt').DataTable({
            responsive: true,
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Organisation Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "organisation",
                        searchableFields: [
                            { field: 'name', isNumeric: false },
                            { field: 'reg_number', isNumeric: false },
                        ],
                        pageSize: data.start,
                        populate: [
                            {
                                path: 'country',
                                model: 'country'

                            }
                        ],
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success : function(res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.name
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.email
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return {
                            true : `<span class="badge badge-success tx-white">Yes</span>`,
                            false : `<span class="badge badge-danger tx-white">No</span>`
                        }[data.active];
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return data?.country?.name
                    },
                    "targets": 3
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link edit_organisation"><i class="fa fa-pencil"></i> Edit</a> <a href="#" class="nav-link delete_organisation"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 4
                }
            ]
        });

        table.on('click', '.delete_organisation', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this account?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right"
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                organisation("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable("organisation");
                        cogoToast.success("Organisation successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.edit_organisation', function(e) {
            e.preventDefault();

            // let name = $("#name");
            // let email = $("#email");
            // let extract_td = table.row($(this).closest('tr')).data();
            //
            // setEditForm(true);
            // setEditId(extract_td.raw._id);
            //
            // $('#admin_form').parsley();
            //
            // name.prop('disabled', true);
            // email.prop('disabled', true);
            // $("#password").prop('required', false);
            //
            // name.val(extract_td.raw.name);
            // email.val(extract_td.raw.email);
            //
            // initializeRoleSearch();
            //
            // let privilege_select = $("#role-select2");
            //
            // let $_option = $("<option selected></option>").val(extract_td.raw.privilege._id).text(capitalize(extract_td.raw.privilege.name));
            // privilege_select.append($_option).trigger('change');
            //
            // $("#modalAccount").modal("show");
        });

        return () => {
            table.destroy();
        }
    }, []);

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop("disabled", false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const handlePolicySubmit = (e) => {
        e.preventDefault();

        const name = $("#policy_name").val();
        const description = $("#policy_description").val();
        const isAdmin = $("#ck_full_access").is(":checked");

        const ACTIONS = {
            all: ["create", "read", "update", "delete", "export", "authorize"],
            view: ["read", "export"],
            manage: ["create", "update", "delete", "authorize"]
        };

        const uniq = (arr) => Array.from(new Set(arr));

        let permissions = [];

        if (isAdmin) {
            permissions = RESOURCES.map(({ resource }) => ({
                resource,
                action: [...ACTIONS.all],
            }));
        } else {
            RESOURCES.forEach(({ resource, view, manage }) => {
                let actions = [];

                if (view && $(view).is(":checked")) {
                    actions = actions.concat(ACTIONS.view);
                }
                if (manage && $(manage).is(":checked")) {
                    actions = actions.concat(ACTIONS.manage);
                }

                if (!view && manage && $(manage).is(":checked")) {
                    actions = actions.concat(ACTIONS.manage);
                }

                actions = uniq(actions);
                if (actions.length) {
                    if (!actions.includes("read")) actions.push("read");
                    permissions.push({ resource, action: uniq(actions) });
                }
            });
        }

        const data = {
            name,
            description,
            system_lock: isAdmin,
            permissions
        };

        if(editForm) {
            Object.assign(data, {id: editId});
            policy("put", data).then((result) => {
                setStateReady(false);

                if(!result.error) {
                    cogoToast.success("Policy successfully updated.", {position: "top-right", hideAfter: 5});
                    resetForm("modalPolicy", "policy_form");
                    reloadTable("policy-dt");
                }
            });

            return false;
        }

        policy("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Policy successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalPolicy", "policy_form");
                reloadTable("policy-dt");
            }
        });
    }

    const handleShowOrganisationModal = () => {
        setWizard(true);
        $('a[href="#organisation"]').tab('show');
        $("#modalOrganisation").modal("show");
    };

    const handleShowPolicyModal = () => {
        setEditForm(false);
        $('#policy_form').parsley();
        $('a[href="#policy"]').tab('show');

        if(!datatable.permission) {
            policyDatatable();
        }

        $("#modalPolicy").modal("show");
    };

    const reloadTable = (id) => {
        $(`#${id}`).DataTable().ajax.reload(null, false);
    };

    const policyDatatable = () => {
        if(datatable.permission) return false;
        datatable.permission = true;

        let table = $('#policy-dt').DataTable({
            responsive: true,
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Policy Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "policy",
                        searchableFields: [
                            { field: 'name', isNumeric: false },
                            { field: 'slug', isNumeric: false },
                        ],
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success : function(res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.name
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return `${data.permissions.length} Permissions`
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return {
                            true : `<span class="badge badge-success tx-white">Yes</span>`,
                            false : `<span class="badge badge-danger tx-white">No</span>`
                        }[data.enforce];
                    },
                    "targets": 2
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link edit_permission"><i class="fa fa-pencil"></i> Edit</a> <a href="#" class="nav-link delete_permission"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 3
                }
            ]
        });

        table.on('click', '.delete_permission', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this account?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 3
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                policy("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable("policy-dt");
                        cogoToast.success("Privilege successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.edit_permission', function(e) {
            e.preventDefault();

            let name = $("#policy_name");
            let description = $("#policy_description");
            let extract_td = table.row($(this).closest('tr')).data();

            setEditForm(true);
            setEditId(extract_td.raw._id);

            $('#policy_form').parsley();

            name.val(extract_td.raw.name);
            description.val(extract_td.raw.description);

            const ALL_ACTIONS = ["create","read","update","delete","export","authorize"];
            const MANAGE_SET  = new Set(["create","update","delete","authorize"]);

            const byResource = (permsArr=[]) => {
                const map = new Map();
                permsArr.forEach(p => map.set(p.resource, new Set(p.action || [])));
                return map;
            };
            const hasAnyManage = (set) => [...MANAGE_SET].some(a => set.has(a));
            const isAllActions = (set) => ALL_ACTIONS.every(a => set.has(a));

            const map = byResource(extract_td.raw.permissions);

            RESOURCES.forEach(({ resource, view, manage }) => {
                const set = map.get(resource);
                if (!set) return;

                const hasView   = set.has("read") || set.has("export");
                const hasManage = hasAnyManage(set);

                if (view && hasView)     $(view).prop("checked", true);
                if (manage && hasManage) $(manage).prop("checked", true);

                if (!view && manage && (hasView || hasManage)) {
                    $(manage).prop("checked", true);
                }
            });

            const everyIsAll =
                RESOURCES.length > 0 &&
                RESOURCES.every(({ resource }) => {
                    const set = map.get(resource);
                    return set && isAllActions(set);
                });

            if (everyIsAll) {
                $("#ck_full_access").prop("checked", true);
                $("#cbWrapper2 input[type=checkbox]").not("#ck_full_access").prop("checked", true).prop("disabled", true);
            } else {
                $("#ck_full_access").prop("checked", false);
                $("#cbWrapper2 input[type=checkbox]").not("#ck_full_access").prop("disabled", false);
            }

            $("#modalPolicy").modal("show");
        });
    }

    const initializeRoleSearch = () => {
        let modalAccount = $('#modalAccount');
        $('#role-select2').select2({
            placeholder: 'Select role permission',
            allowClear: true,
            width:"100%",
            maximumSelectionLength: 1,
            dropdownParent: modalAccount,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization": token,
                },
                data: function(query) {
                    return {
                        query: query,
                        collection: "privilege"
                    };
                },
                processResults: function(data) {
                    return {
                        results: $.map(data, function(item) {
                            return {
                                text: capitalize(item.name),
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        });
    }

    const handleAutoCheckView = (id, e) => {
        const data =  $(`#${id}`);
        e.target.checked ? data.prop("checked", true).prop("disabled", true) :  data.prop("checked", false).prop("disabled", false);
    }

    const handleCheckAll = (e) => {
        const checked = e.target.checked;
        const $children = $("#cbWrapper2 input[type=checkbox]").not("#ck_full_access");
        checked ? $children.prop("checked", true).prop("disabled", true) :  $children.prop("checked", false).prop("disabled", false);
    }

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Organisation</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Organisation</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-success btn-uppercase mg-l-5 outline-none" onClick={handleShowOrganisationModal.bind()}><i className="wd-10 mg-r-5 fa fa-building"></i> Add Organisation</button>
                        <button className="btn btn-sm pd-x-15 btn-outline-secondary btn-uppercase mg-l-5 outline-none" onClick={handleShowPolicyModal.bind()}><i className="wd-10 mg-r-5 fa fa-plus"></i> Add Policy</button>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12">
                        <div className="card card-crypto">
                            <div className="card-header pd-y-8 d-sm-flex align-items-center justify-content-between">
                                <nav className="nav nav-line">
                                    <a href="#organisation" className="nav-link active" data-toggle="tab">Organisation</a>
                                    <a href="#policy" className="nav-link" onClick={policyDatatable.bind()} data-toggle="tab">Policy</a>
                                </nav>
                            </div>
                            <div className="card-body">
                                <div className="tab-content">
                                    <div id="organisation" className="tab-pane fade active show">
                                        <table id="organisation-dt" className="table">
                                            <thead>
                                            <tr>
                                                <th className="wd-20p">Name</th>
                                                <th className="wd-20p">Email</th>
                                                <th className="wd-20p">Active</th>
                                                <th className="wd-20p">Country</th>
                                                <th className="wd-20p">Actions</th>
                                            </tr>
                                            </thead>
                                        </table>
                                    </div>

                                    <div id="policy" className="tab-pane fade">
                                        <table id="policy-dt" className="table" style={{width:'100%'}}>
                                            <thead>
                                            <tr>
                                                <th className="wd-25p">Name</th>
                                                <th className="wd-25p">Permissions</th>
                                                <th className="wd-25p">Enforce</th>
                                                <th className="wd-25p">Actions</th>
                                            </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalOrganisation" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30 border-bottom-0">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={() => {
                                        setWizard(false);
                                        $("#modalOrganisation").modal("hide");
                                        $(".modal-backdrop").remove();
                                    }} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">Create Organisation</h4><p className="tx-13 tx-color-02 mg-b-0">Create new organisation and account holder.</p></div>
                                </div>
                                <div className="modal-body pd-0">
                                    {wizard ? <Wizard onFinish={() => {
                                        setWizard(false);
                                        reloadTable("organisation-dt");
                                        $("#modalOrganisation").modal("hide");
                                        $(".modal-backdrop").remove();
                                    }}/> : null}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalPolicy" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalPolicy", "policy_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">{editForm ? "Edit Policy" : "Create Policy"}</h4><p className="tx-13 tx-color-02 mg-b-0">{editForm ? "Edit" : "Create"} policy to assign for the organisation.</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="policy_form" className="parsley-style-1" onSubmit={handlePolicySubmit.bind()}>
                                        <div id="nameWrapper" className="form-group parsley-input">
                                            <label>Name<span className="tx-danger">*</span></label>
                                            <input id="policy_name" type="text" className="form-control"
                                                   placeholder="Enter key name"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#nameWrapper" required/>
                                        </div>

                                        <div id="descWrapper" className="form-group parsley-input">
                                            <label>Description<span className="tx-danger">*</span></label>
                                            <textarea id="policy_description" className="form-control"
                                                      placeholder="Enter description"
                                                      autoComplete="none"
                                                      rows={3}
                                                      data-parsley-class-handler="#descWrapper" required/>
                                        </div>

                                        <div className="form-group">
                                            <div data-label="Resources" className="df-example mg-b-5">
                                                <div id="cbWrapper2" className="parsley-checkbox pos-relative">
                                                    <h6>Full Access</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox" name="_form[]"
                                                               data-parsley-mincheck="1"
                                                               data-parsley-class-handler="#cbWrapper2"
                                                               onChange={handleCheckAll.bind()}
                                                               data-parsley-errors-container="#cbErrorContainer2"
                                                               data-parsley-multiple="_form" id="ck_full_access" required/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_full_access">Admin (All permissions)</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Grants unrestricted access across the console. Administrators can configure system settings, manage every module and dataset, create and remove users, assign or revoke roles and permissions, and review audit history via the activity log. Assign only to trusted superusers; changes are immediate and may be irreversible.</p>
                                                    </div>

                                                    <hr/>

                                                    <h6>Account</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_account"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_account">Manage users and permissions (Access Control)</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Provides full access to user account and permission management. Users with this role can create and maintain accounts, assign or revoke roles, adjust permission levels, deactivate or remove accounts, and review access activity. This permission ensures complete control over who can access the system and what actions they are allowed to perform.</p>
                                                    </div>

                                                    <hr/>

                                                    <h6>Financial Data</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_financial"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_financial">View financial data, orders, and cancellation survey responses</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">View financial reports, sales reports, and subscriptions; view users transaction metrics on the User transaction page; view revenue information for any associated collector.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_financial")}
                                                               id="ck_manage_financial"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_financial">Manage orders and subscriptions</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">View orders, refund orders, and cancel subscriptions. Users also need the ‘View financial data’ permission to view aggregate financial reports.</p>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Note: If you enable payout while finance is disabled, it will be rejected.</p>
                                                    </div>

                                                    <hr/>

                                                    <h6>Waste Collection</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_waste_collection"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_waste_collection">View waste collection, status and schedules</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Grants access to view waste collection records, schedules, and subscription details. Users can check bin collection status, including whether a household’s bins have been serviced.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_waste_collection")}
                                                               id="ck_manage_waste_collection"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_waste_collection">Manage waste collections &amp; status</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Authorizes the management of waste collection operations, including updating collection records, maintaining schedules, tracking subscription services, and confirming or correcting bin collection statuses.</p>
                                                    </div>

                                                    <hr/>

                                                    <h6>Organization</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_organization"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_organization">View organization &amp; policies</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Grants access to view organizational details, company structure, and defined policies. Users can review compliance information, organizational hierarchy, and governance records but cannot make modifications.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_organization")}
                                                               id="ck_manage_organisation"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_organisation">Manage organization and policies</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Authorizes full management of organizational records and policies, including creating or updating governance rules, modifying organizational structures, and maintaining compliance documentation..</p>
                                                    </div>

                                                    <hr/>

                                                    <h6>Zone</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_zone"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_zone">View zone</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Grants the ability to view all mapped zones established for waste collection. Users can access zone boundaries, assigned collectors, and zone details but cannot alter them.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_zone")}
                                                               id="ck_manage_zone"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_zone">Manage zone</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Authorizes the creation, modification, and deletion of zones, including assigning collectors to specific service areas.</p>
                                                    </div>

                                                    <hr/>

                                                    <h6>Product</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_product"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_product">View products &amp; pricing</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Permits viewing of all products, pricing structures, and subscription plans associated with designated zones.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_product")}
                                                               id="ck_manage_product"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_product">Manage products</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Enables full management of products and pricing, including adding new offerings, updating pricing rules, and removing outdated entries.</p>
                                                    </div>

                                                    <hr/>

                                                    <h6>Customer</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_customer"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_customer">View customer details, addresses &amp; subscriptions</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Allows access to customer profiles, subscription details, household information, and service usage history in a read-only capacity.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_customer")}
                                                               id="ck_manage_customer"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_customer">Manage customer</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Authorizes the creation and maintenance of customer accounts, including subscription activation, updates, renewals, and cancellations.</p>
                                                    </div>

                                                    <hr/>

                                                    <h6>Payout</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_payout"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_payout">View payout &amp; history</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Provides access to view payout records, transaction history, and real-time payment tracking for garbage collectors.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_payout")}
                                                               id="ck_manage_payout"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_payout">Manage payout</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Grants authority to initiate, approve, and adjust payout transactions via bank or mobile money channels.</p>
                                                    </div>

                                                    <hr/>

                                                    <h6>Collector</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_collector"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_collector">View collector</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Permits visibility into collector profiles, assigned zones, operational metrics, and payout summaries.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_collector")}
                                                               id="ck_manage_collector"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_collector">Manage collector, schedules, zone &amp; product</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Authorizes the creation, assignment, and maintenance of collector accounts, including performance updates and account suspension or deactivation.</p>
                                                    </div>

                                                    <hr/>

                                                    <h6>Report</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_report"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_report">View report</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Grants access to view illegal dumping reports submitted by customers, including associated images and incident details.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_report")}
                                                               id="ck_manage_report"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_report">Manage report</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Authorizes validation, approval, and resolution of reports, including coordinating follow-up enforcement actions.</p>
                                                    </div>

                                                    <hr/>

                                                    <h6>Commission</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_commission"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_commission">View commission</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Permits access to view commission structures, rates, and earnings associated with products and collectors.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_commission")}
                                                               id="ck_manage_commission"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_commission">Manage commission</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Enables configuration and adjustment of commission policies, including establishing new rates and linking commissions to products or collectors.</p>
                                                    </div>

                                                    <hr/>

                                                    <h6>QR Code</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_qrcode"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_qrcode">View QR Codes &amp; export</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Provides visibility into generated QR codes assigned to households or customers for service verification.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_qrcode")}
                                                               id="ck_manage_qrcode"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_qrcode">Manage QR codes</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Authorizes the generation, updating, and printing of QR codes, including re-issuance for lost or invalid codes.</p>
                                                    </div>

                                                    <h6>Enquiries</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_enquiry"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_enquiry">View enquiries</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Allows viewing of customer service requests, such as fumigation, pest control, and bulk waste removal.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_enquiry")}
                                                               id="ck_manage_enquiry"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_enquiry">Manage enquiries and approve</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Authorizes review, approval, assignment, and status tracking of customer service requests through completion.</p>
                                                    </div>

                                                    <h6>Media</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_media"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_media">View media</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Grants access to view published content including announcements, articles, and multimedia posted within the platform.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_media")}
                                                               id="ck_manage_media"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_media">Manage media</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Enables creation, publishing, editing, and removal of media content for customer engagement and information dissemination.</p>
                                                    </div>

                                                    <h6>Message</h6>
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="ck_view_message"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_view_message">View message</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Allows access to the history of notifications, broadcasts, and SMS communications sent to customers.</p>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               onChange={handleAutoCheckView.bind(null, "ck_view_message")}
                                                               id="ck_manage_message"/>
                                                        <label className="custom-control-label mb-1" htmlFor="ck_manage_message">Send messages, reminder and Push Notification</label>
                                                        <p className="tx-italic tx-sm-13 tx-gray-900 mb-4">Authorizes the creation and distribution of messages, including push notifications and SMS, to targeted customers or the entire user base.</p>
                                                    </div>

                                                    <div id="cbErrorContainer2" className="wd-100p pos-absolute b-0 l-0"/>
                                                </div>
                                            </div>
                                        </div>

                                        {stateReady ? <button disabled className="btn btn-success btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : editForm ? <button className="btn btn-success btn-block">Update Policy</button> : <button className="btn btn-success btn-block">Create Policy</button>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p className="mg-b-0 data-message">Empty</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                    <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Organisation;
